var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8013)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8013",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 49.0232C23.3737 49.0235 21.7516 48.86 20.1583 48.5349C17.0854 47.9056 14.1665 46.6773 11.5682 44.9202C7.70582 42.313 4.68242 38.6417 2.86425 34.3511C2.25002 32.8977 1.7812 31.3872 1.46464 29.8415C0.81387 26.6466 0.81387 23.3532 1.46464 20.1583C2.09393 17.0854 3.32214 14.1665 5.07919 11.5681C7.68653 7.70573 11.358 4.68233 15.6488 2.86424C17.1021 2.25002 18.6126 1.78119 20.1582 1.46463C23.3531 0.813874 26.6464 0.813874 29.8413 1.46463C32.9142 2.09396 35.8332 3.32224 38.4315 5.07937C42.2939 7.68673 45.3173 11.3582 47.1353 15.649C47.7496 17.1023 48.2184 18.6127 48.535 20.1584C49.1857 23.3533 49.1857 26.6466 48.535 29.8416C47.9056 32.9145 46.6773 35.8335 44.9202 38.4318C42.3129 42.2942 38.6414 45.3176 34.3506 47.1357C32.8973 47.75 31.3868 48.2189 29.8411 48.5355C28.2478 48.8603 26.6259 49.0237 24.9998 49.0232ZM15.6875 11.0174C15.3415 11.0153 14.9995 11.0912 14.6869 11.2394C14.3743 11.3877 14.0991 11.6044 13.8817 11.8736L11.7333 14.4888C11.2673 15.0418 11.0134 15.7427 11.0172 16.4659V35.9249C11.0181 36.7503 11.3465 37.5417 11.9302 38.1254C12.5138 38.709 13.3052 39.0373 14.1307 39.0383H35.9248C36.7503 39.0373 37.5416 38.709 38.1253 38.1253C38.709 37.5416 39.0373 36.7502 39.0383 35.9248V16.4658C39.0421 15.7426 38.7882 15.0417 38.3222 14.4888L36.1584 11.8735C35.9443 11.6046 35.6719 11.3877 35.3618 11.2394C35.0517 11.0911 34.7119 11.0151 34.3682 11.0173L15.6875 11.0174ZM25.0277 33.5898L16.4658 25.0279H21.9143V21.9143H28.1412V25.0278H33.5897L25.0278 33.5897L25.0277 33.5898ZM35.7225 14.1306H14.3177L15.5785 12.5739H34.2592L35.7225 14.1306Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.153897742ded0c8cde133c5c790a3f40.svg";
export { ForwardRef as ReactComponent };